import React, { FC, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import LangDropdown from "./LangDropdown";
//import CurrencyDropdown from "./CurrencyDropdown";
import BbeSearchForm2Mobile from "components/HeroSearchForm2Mobile/BbeSearchForm2Mobile";
import { useClient } from "ClientContext";
import { useTranslation } from "react-i18next";
import { useCurrency } from "hooks/useCurrency";
import { GlobalCurrencyType } from "ClientContext";

export interface MainNav2Props {
  className?: string;
}

const MainNav2: FC<MainNav2Props> = ({ className = "" }) => {
   const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { clientName, requestType, internal_ID, actions, integration_TYPE,setGlobal_currency_details,global_language,global_currency } = useClient();
  
  // Use the currency hook with the client's internal_ID and action
  const { currencies, loading, error, fetchCurrencies } = useCurrency({
    internal_ID,
    action: actions?.fetchListingCurrencies
  });
  
  // Fetch currencies when component mounts and integration type is lodgify
  useEffect(() => {
    if (integration_TYPE === "lodgify" && actions?.fetchListingCurrencies) {
      fetchCurrencies({ currency:global_currency[0] , defaultLang: global_language });
    }
  }, [integration_TYPE, actions?.fetchListingCurrencies]);
  
// Update global currency details when currencies change
useEffect(() => {
 // console.log("Updating currency :", currencies);
  setGlobal_currency_details(currencies as GlobalCurrencyType);
}, [currencies, setGlobal_currency_details]);
 
  useEffect(() => {
    // Store the current path as the last visited in localStorage
    localStorage.setItem("lastLocation", location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    // Retrieve the last location from localStorage
    const lastVisited = localStorage.getItem("lastLocation");
    if (lastVisited) {
    }
  }, []);

  const isValidPath =
    location.pathname === "/listings-list" ||
    location.pathname.startsWith("/search");
  return (
    <div
      className={
        isValidPath
          ? `nc-Header sticky top-0 w-full left-0 right-0 z-40 nc-header-bg shadow-none dark:border-b dark:border-neutral-700`
          : ``
      }
    >
      <div className={`nc-MainNav1 nc-MainNav2 relative z-10 ${className}`}>
        <div className="px-4 lg:container py-4 lg:py-5 relative flex items-center justify-between">
          {/* Container for Back Button --- BACK BUTTON HIDDEN AS NOT NEEDED */}
          <div className="flex items-center space-x-3 sm:space-x-8 lg:space-x-10">
            {requestType!=="SINGLE_LISTING" && location.pathname !== "/listings-list" &&
              (location.pathname.includes("/listings-list/") ? (
                <ButtonPrimary
                  className="absolute left-2 top-6 transform -translate-y-1/2 inline-flex w-auto px-4 justify-between items-center"
                  onClick={() => navigate("/listings-list")}
                >
                  <ArrowLeftIcon className="w-5 h-5" />
                  <span>{t("Back")}</span>
                </ButtonPrimary>
              ) : (
                <ButtonPrimary
                  className="absolute left-2 top-6 transform -translate-y-1/2"
                  onClick={() => navigate(-1)}
                >
                  <ArrowLeftIcon className="w-5 h-5" /> {t("Back")}
                </ButtonPrimary>
              ))}
          </div>

          {/* Combined Container */}
          <div className="flex flex-col lg:flex-row w-full items-center justify-between">
            {/* Centered and Full-Width Search Form for Mobile */}
            {(location.pathname === "/listings-list" ||
              location.pathname.startsWith("/search")) && (
                <div className="lg:hidden flex justify-center items-center w-full px-4">
                  <div className="w-full max-w-lg">
                    <BbeSearchForm2Mobile />
                  </div>
                </div>
              )}

            {/* Right-aligned Language Dropdown */}
            <div className="flex flex-1 items-center justify-end w-full lg:w-auto mt-4 lg:mt-0 text-neutral-700 dark:text-neutral-100">
              <div className="flex items-center space-x-1">
                {/* Uncomment or Add Currency Dropdown if needed */}
                {/* <CurrencyDropdown /> */}
                {(clientName === "chaletmetsa" ||
                  clientName === "chaletsduplateaudeshautesgorges" ||
                  clientName === "lizbeth---marmolejo") && (
                    <LangDropdown />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNav2;
